import { Image, useToast } from "@chakra-ui/react";
import imgContent01 from "../../../assets/images/content/bg/content-dataservice-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-dataservice-02.png";
import imgContent03 from "../../../assets/images/content/bg/content-dataservice-03.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-dataservice-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-dataservice-02.png";
import tContent03 from "../../../assets/images/content/bg/content-tablet-dataservice-03.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-dataservice-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-dataservice-02.png";
import mContent03 from "../../../assets/images/content/bg/content-mobile-dataservice-03.png";

import { styled } from "styled-components";
import { ScreenContext } from "../../../components/ScreenProvider";
import { useContext } from "react";
import SlideContents from "../../../components/SlideContents";
import { DataBuildInstanceList } from "../../../assets/datas/ConstantLists";

const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BtnService = styled.button`
  width: 300px;
  height: 60px;
  background: #333333;
  color: #ffffff;
  font-size: 18px;
  border-radius: 62px;
  margin-bottom: 10px;
  &:hover {
    background: #969696;
  }

  @media(max-width: 1024px) {
    width: 30vw;
    height: 50px;
  }
`;

const DataService = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    },
    {
      pc: imgContent03,
      mobile: mContent03,
      tablet: tContent03,
    },
  ];
  const toast = useToast();
  return (
    <DataWrapper>
      <Image src={contents[0][screen]} w={"100%"} alt="" />
      <SlideContents datas={DataBuildInstanceList} />
      <Image src={contents[1][screen]} w={"100%"} alt="" />
      <BtnService onClick={() => toast({ title: "준비중입니다.", status: "info" })}>문의하기</BtnService>
      <Image src={contents[2][screen]} w={"100%"} alt="" />

    </DataWrapper>
  );
};

export default DataService;